import {BrowserModule} from '@angular/platform-browser';
import {APP_INITIALIZER, NgModule} from '@angular/core';

import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';

import {AlertModule} from 'ngx-bootstrap/alert';
import {AlertListComponent} from './shared/components/alert-list/alert-list.component';
import {ProgressbarModule} from 'ngx-bootstrap/progressbar';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {ToolviewComponent} from './views/toolview/toolview.component';
import {MainviewComponent} from './views/mainview/mainview.component';
import {HTTP_INTERCEPTORS, HttpClientModule} from '@angular/common/http';
import {CommonModule} from '@angular/common';
import {HeaderComponent} from './views/components/header/header.component';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';

import {AdminviewComponent} from './views/adminview/adminview.component';
import {HttptokenInterceptor} from './security/httptoken.interceptor';
import {WelcomeInterfaceComponent} from './views/components/welcome-interface/welcome-interface.component';

import {BsDropdownModule} from 'ngx-bootstrap/dropdown';
import {CarouselModule} from 'ngx-bootstrap/carousel';
import {ModalModule} from 'ngx-bootstrap/modal';
import {CollapseModule} from 'ngx-bootstrap/collapse';
import {TabsModule} from 'ngx-bootstrap/tabs';
import {BsDatepickerModule} from 'ngx-bootstrap/datepicker';
import {NewsEditComponent} from './views/adminview/news/news-edit/news-edit.component';
import {NewsListComponent} from './views/adminview/news/news-list/news-list.component';
import {NewsMainComponent} from './views/adminview/news/news-main/news-main.component';

import {HelpsEditComponent} from './views/adminview/helps/helps-edit/helps-edit.component';
import {HelpsListComponent} from './views/adminview/helps/helps-list/helps-list.component';

import {MandantEditComponent} from './views/adminview/mandant/mandant-edit/mandant-edit.component';
import {MandantListComponent} from './views/adminview/mandant/mandant-list/mandant-list.component';
import {MandantMainComponent} from './views/adminview/mandant/mandant-main/mandant-main.component';

import {ToolsEditComponent} from './views/adminview/tools/tools-edit/tools-edit.component';
import {ToolsListComponent} from './views/adminview/tools/tools-list/tools-list.component';
import {ToolsMainComponent} from './views/adminview/tools/tools-main/tools-main.component';

import {RoleMainComponent} from './views/adminview/role/role-main/role-main.component';
import {RoleListComponent} from './views/adminview/role/role-list/role-list.component';
import {RoleEditComponent} from './views/adminview/role/role-edit/role-edit.component';

import {LanguageMainComponent} from './views/adminview/language/language-main/language-main.component';
import {LanguageListComponent} from './views/adminview/language/language-list/language-list.component';
import {LanguageEditComponent} from './views/adminview/language/language-edit/language-edit.component';

import {MatTableModule} from '@angular/material/table';
import {MatSortModule} from '@angular/material/sort';


import {MatFormFieldModule} from '@angular/material/form-field';
import {MatInputModule} from '@angular/material/input';
import {MatTableExporterModule} from 'mat-table-exporter';

import {EditorModule} from '@tinymce/tinymce-angular';
import {TooltipModule} from 'ngx-bootstrap/tooltip';

import {MainLandingComponent} from './views/components/main-landing/main-landing.component';
import {HelpviewComponent} from './views/helpview/helpview.component';
import {HelpSectionComponent} from './views/helpview/help-section/help-section.component';


import {AttributeMainComponent} from './views/adminview/attribute-groupe/attribute-main/attribute-main.component';
import {AttributeEditComponent} from './views/adminview/attribute-groupe/attribute-edit/attribute-edit.component';
import {AttributeListComponent} from './views/adminview/attribute-groupe/attribute-list/attribute-list.component';
import {AttributeTypeListComponent} from './views/adminview/attribute-groupe/attribute-type/attribute-type-list/attribute-type-list.component';
import {AttributeTypeMainComponent} from './views/adminview/attribute-groupe/attribute-type/attribute-type-main/attribute-type-main.component';
import {AttributeTypeEditComponent} from './views/adminview/attribute-groupe/attribute-type/attribute-type-edit/attribute-type-edit.component';

import {SidebarModule} from 'ng-sidebar';

import {UsersListComponent} from './views/adminview/users/users-list/users-list.component';
import {UsersMainComponent} from './views/adminview/users/users-main/users-main.component';
import {MatPaginatorModule} from '@angular/material/paginator';
import {ActiveInGridComponent} from './views/components/active-in-grid/active-in-grid.component';
import {DashboardComponent} from './views/adminview/dashboard/dashboard.component';
import {HelpsMainComponent} from './views/adminview/helps/helps-main/helps-main.component';
import {MatSelectModule} from '@angular/material/select';
import {NgSelectModule} from '@ng-select/ng-select';

import {LastLogsComponent} from './views/adminview/dashboard/last-app-events/last-logs.component';
import {GlobalsService} from './shared/services/globals.service';
import {ServiceStatusComponent} from './views/adminview/dashboard/service-status/service-status.component';
import {LogsMainComponent} from './views/adminview/logs/logs-main/logs-main.component';
import {LogsDetailsComponent} from './views/adminview/logs/logs-details/logs-details.component';
import {LogsListComponent} from './views/adminview/logs/logs-list/logs-list.component';
import {SyncrInGridComponent} from './views/components/syncr-in-grid/syncr-in-grid.component';

import {UserprofilviewComponent} from './views/userprofilview/userprofil-view/userprofilview.component';
import {UserprofilEditComponent} from './views/userprofilview/userprofil-edit/userprofil-edit.component';
import {UserprofilMainComponent} from './views/userprofilview/userprofil-main/userprofil-main.component';
import {DropdownUserComponent} from './shared/components/dropdown-user/dropdown-user.component';

import {OrderviewComponent} from './views/orderview/orderview.component';

import {UsersToolsListComponent} from './views/adminview/users/users-tools-list/users-tools-list.component';
import {UsersToolsEditComponent} from './views/adminview/users/users-tools-edit/users-tools-edit.component';
import {EllipsisUserGridComponent} from './views/components/ellipsis-user-grid/ellipsis-user-grid.component';
import {UsersToolMainComponent} from './views/adminview/users/users-tool-main/users-tool-main.component';
import {UsersToolsEditAosComponent} from './views/adminview/users/users-tools-edit-aos/users-tools-edit-aos.component';
import {UsersToolsEditCavokComponent} from './views/adminview/users/users-tools-edit-cavok/users-tools-edit-cavok.component';


import {WebshopOrdersComponent} from './views/orderview/webshop-orders/webshop-orders.component';
import {AosOrdersComponent} from './views/orderview/aos-orders/aos-orders.component';
import {CrudListComponent} from '@shared/library/crud-library/crud-list/crud-list.component';
import {CrudEditComponent} from '@shared/library/crud-library/crud-edit/crud-edit.component';
import {FormlyHorizontalWrapper} from '@shared/library/formly/formly-horizontal-wrapper';
import {FormlyFieldNgSelect} from '@shared/library/formly/ng-select-type.components';
import {FormlyFieldFile} from '@shared/library/formly/file-type.component';
import {FileValueAccessor} from '@shared/library/formly/file-value-accessor';
import {FormlyBootstrapModule} from '@ngx-formly/bootstrap';
import {FormlyModule} from '@ngx-formly/core';

import {UserEllipsisComponent} from './views/adminview/users/user-ellipsis/user-ellipsis.component';
import {AosOrderDetailsComponent} from './views/orderview/aos-orders/aos-order-details/aos-order-details.component';
import {TranslationMainComponent} from './views/adminview/translation/translation-main/translation-main.component';
import {TranslationEditComponent} from './views/adminview/translation/translation-edit/translation-edit.component';
import {TranslationListComponent} from './views/adminview/translation/translation-list/translation-list.component';
import {TranslationAddCsvComponent} from './views/adminview/translation/translation-add-csv/translation-add-csv.component';
import {PasswordforgotviewComponent} from './views/passwordforgotview/passwordforgotview.component';
import {PasswordresetviewComponent} from './views/passwordresetview/passwordresetview.component';
import {CompaniesListComponent} from './views/adminview/companies/companies-list/companies-list.component';
import {CompaniesEditComponent} from './views/adminview/companies/companies-edit/companies-edit.component';
import {CompaniesMainComponent} from './views/adminview/companies/companies-main/companies-main.component';

import {NgMultiSelectDropDownModule} from 'ng-multiselect-dropdown';
import {DosOrdersComponent} from './views/orderview/dos-orders/dos-orders.component';
import {DosOrderDetailsComponent} from './views/orderview/dos-orders/dos-order-details/dos-order-details.component';
import {AosOrderSearchComponent} from './views/orderview/aos-orders/aos-order-search/aos-order-search.component';
import {UsersEditComponent} from './views/adminview/users/users-edit/users-edit.component';
import {ColCardWrapperComponent} from './shared/components/col-card-wrapper/col-card-wrapper.component';
import {BusinessCardOrdersComponent} from './views/orderview/business-card-orders/business-card-orders.component';
import {BusinessCardOrderDetailsComponent} from './views/orderview/business-card-orders/business-card-order-details/business-card-order-details.component';
import {BusinessCardOrderSearchComponent} from './views/orderview/business-card-orders/business-card-order-search/business-card-order-search.component';
import {OrderDocumentListComponent} from './views/orderview/business-card-orders/business-card-order-details/order-document-list/order-document-list.component';
import {GenericOrdersMainComponent} from './views/orderview/generic-orders/generic-orders-main/generic-orders-main.component';
import {GenericOrdersListComponent} from './views/orderview/generic-orders/generic-orders-list/generic-orders-list.component';
import {GenericOrdersEditComponent} from './views/orderview/generic-orders/generic-orders-edit/generic-orders-edit.component';
import {MarketgroupsMainComponent} from './views/adminview/marketgroups/marketgroups-main/marketgroups-main.component';
import {MarketgroupsListComponent} from './views/adminview/marketgroups/marketgroups-list/marketgroups-list.component';
import {MarketgroupsEditComponent} from './views/adminview/marketgroups/marketgroups-edit/marketgroups-edit.component';
import {MarketsMainComponent} from './views/adminview/markets/markets-main/markets-main.component';
import {MarketsListComponent} from './views/adminview/markets/markets-list/markets-list.component';
import {MarketsEditComponent} from './views/adminview/markets/markets-edit/markets-edit.component';
import {MarketsEllipsisComponent} from './views/adminview/markets/markets-ellipsis/markets-ellipsis.component';

import {FlagcategoriesMainComponent} from '@views/adminview/flagcategories/flagcategories-main/flagcategories-main.component';
import {FlagcategoriesListComponent} from '@views/adminview/flagcategories/flagcategories-list/flagcategories-list.component';
import {FlagcategoriesEditComponent} from '@views/adminview/flagcategories/flagcategories-edit/flagcategories-edit.component';
import {FlagsEditComponent} from '@views/adminview/flags/flags-edit/flags-edit.component';
import {FlagsListComponent} from '@views/adminview/flags/flags-list/flags-list.component';
import {FlagsMainComponent} from '@views/adminview/flags/flags-main/flags-main.component';
import {FormlyFieldNgSelect2} from '@shared/library/formly/ng-select2-type.components';
import {UploadsEditComponent} from '@views/adminview/uploads/uploads-edit/uploads-edit.component';
import {UploadsListComponent} from '@views/adminview/uploads/uploads-list/uploads-list.component';
import {UploadsMainComponent} from '@views/adminview/uploads/uploads-main/uploads-main.component';
import {CompaniesUsersComponent} from './views/adminview/companies/companies-users/companies-users.component';
import {FormlyFieldEditor} from '@shared/library/formly/editor-type.components';
import {CrudListElementButtonsComponent} from '@shared/library/crud-library/crud-list/crud-list-element-buttons/crud-list-element-buttons.component';
import { BlockedUsersComponent } from './views/adminview/dashboard/blocked-users/blocked-users.component';
import { SpinnerComponent } from './shared/components/spinner/spinner.component';
import {FormlyFieldDatePicker} from '@shared/library/formly/datepicker-type.components';
import {RepeatTypeComponent} from '@shared/library/formly/repeat-section-type';
import {AppdomainEditComponent} from '@views/adminview/appdomain/appdomain-edit/appdomain-edit.component';
import {AppdomainListComponent} from '@views/adminview/appdomain/appdomain-list/appdomain-list.component';
import {AppdomainMainComponent} from '@views/adminview/appdomain/appdomain-main/appdomain-main.component';
import {UnblockUserViewComponent} from '@views/unblockuserview/unblock-user-view.component';
import { PagenotfoundComponent } from './views/pagenotfound/pagenotfound.component';
import {JsonapiListTemplateTypeComponent} from "@shared/library/formly/jsonapi-list-template-type";
import {MatPasswordStrengthModule} from '@angular-material-extensions/password-strength';
import {FormlyFieldTabs} from '@shared/library/formly/tabs.type';
import { ToollistviewComponent } from './views/toollistview/toollistview.component';
import {PackshotVideoLonginesOrdersComponent} from '@views/orderview/packshot-video-longines/packshot-video-longines-orders.component';
import {PackshotVideoLonginesOrderDetailsComponent} from '@views/orderview/packshot-video-longines/packshot-video-longines-order-details/packshot-video-longines-order-details.component';
import {FormlyFieldCustomTemplate} from '@shared/library/formly/custom-template-field-type';
import {MatTableDataSource} from '@angular/material/table';
// import {MatDatepickerModule} from '@angular/material/datepicker';
// import {MatNativeDateModule} from '@angular/material';
// import { MatMomentDateModule } from '@angular/material-moment-adapter';
// import {EditorModule} from '@tinymce/tinymce-angular';

const initializerConfigFn = (globalsservice: GlobalsService) => {
  return () => {
    return globalsservice.loadAppConfig();
  };
};

@NgModule({
  declarations: [
    AppComponent,
    MainviewComponent,
    ToolviewComponent,
    HeaderComponent,
    AdminviewComponent,

    WelcomeInterfaceComponent,

    AlertListComponent,
    NewsEditComponent,
    NewsListComponent,
    NewsMainComponent,
    HelpsMainComponent,
    HelpsEditComponent,
    HelpsListComponent,
    MandantEditComponent,
    MandantListComponent,
    MandantMainComponent,
    ToolsEditComponent,
    ToolsListComponent,
    ToolsMainComponent,
    RoleMainComponent,
    RoleListComponent,
    RoleEditComponent,
    AppdomainMainComponent,
    AppdomainListComponent,
    AppdomainEditComponent,
    AttributeMainComponent,
    AttributeListComponent,
    AttributeEditComponent,
    AttributeTypeMainComponent,
    AttributeTypeListComponent,
    AttributeTypeEditComponent,

    WelcomeInterfaceComponent,
    MainLandingComponent,
    HelpviewComponent,
    HelpSectionComponent,
    LanguageMainComponent,
    LanguageListComponent,
    LanguageEditComponent,

    UsersMainComponent,
    UsersListComponent,
    ActiveInGridComponent,

    RoleEditComponent,
    AttributeMainComponent,
    AttributeListComponent,
    AttributeEditComponent,
    AttributeTypeMainComponent,
    AttributeTypeListComponent,
    AttributeTypeEditComponent,
    RoleEditComponent,
    DashboardComponent,
    LastLogsComponent,
    ServiceStatusComponent,
    LogsMainComponent,
    LogsDetailsComponent,
    LogsListComponent,
    SyncrInGridComponent,
    UserprofilviewComponent,
    UserprofilEditComponent,
    UserprofilMainComponent,
    DropdownUserComponent,
    OrderviewComponent,

    UsersToolsListComponent,
    UsersToolsEditComponent,
    EllipsisUserGridComponent,
    UsersToolMainComponent,
    UsersToolsEditAosComponent,
    UsersToolsEditCavokComponent,

    AosOrdersComponent,
    WebshopOrdersComponent,
    PackshotVideoLonginesOrdersComponent,

    CrudListComponent,
    CrudEditComponent,
    FormlyHorizontalWrapper,
    FormlyFieldNgSelect,
    FormlyFieldNgSelect2,
    FormlyFieldTabs,
    RepeatTypeComponent,
    JsonapiListTemplateTypeComponent,
    FormlyFieldDatePicker,
    FormlyFieldEditor,
    FormlyFieldFile,
    FormlyFieldCustomTemplate,
    FileValueAccessor,
    CrudListElementButtonsComponent,
    UserEllipsisComponent,

    AosOrderDetailsComponent,
    TranslationMainComponent,
    TranslationEditComponent,
    TranslationListComponent,
    TranslationAddCsvComponent,
    PasswordforgotviewComponent,
    PasswordresetviewComponent,
    UnblockUserViewComponent,
    CompaniesListComponent,
    CompaniesEditComponent,
    CompaniesMainComponent,
    DosOrdersComponent,
    DosOrderDetailsComponent,
    PackshotVideoLonginesOrderDetailsComponent,
    AosOrderSearchComponent,
    UsersEditComponent,
    ColCardWrapperComponent,
    BusinessCardOrdersComponent,
    BusinessCardOrderDetailsComponent,
    BusinessCardOrderSearchComponent,
    OrderDocumentListComponent,
    GenericOrdersMainComponent,
    GenericOrdersListComponent,
    GenericOrdersEditComponent,
    MarketgroupsMainComponent,
    MarketgroupsListComponent,
    MarketgroupsEditComponent,
    MarketsMainComponent,
    MarketsListComponent,
    MarketsEditComponent,
    MarketsEllipsisComponent,
    FlagcategoriesEditComponent,
    FlagcategoriesMainComponent,
    FlagcategoriesListComponent,
    FlagsEditComponent,
    FlagsListComponent,
    FlagsMainComponent,
    UploadsEditComponent,
    UploadsListComponent,
    UploadsMainComponent,
    CompaniesUsersComponent,
    BlockedUsersComponent,
    SpinnerComponent,
    PagenotfoundComponent,
    ToollistviewComponent,
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    AppRoutingModule,
    SidebarModule.forRoot(),

    CarouselModule,
    BsDropdownModule.forRoot(),

    AlertModule.forRoot(),
    CarouselModule.forRoot(),
    CollapseModule,
    TabsModule.forRoot(),
    ModalModule.forRoot(),
    MatTableModule,
    MatSortModule,
    MatPaginatorModule,
    MatFormFieldModule,
    MatInputModule,
    //   MatNativeDateModule, MatMomentDateModule,
    //   MatDatepickerModule,
    //   BsDatepickerModule,
    BsDatepickerModule.forRoot(),
    EditorModule,
    TooltipModule.forRoot(),
    //  EditorModule

    BsDropdownModule,
    MatSelectModule,
    NgSelectModule,

    MatTableExporterModule,
    ProgressbarModule.forRoot(),

    MatPasswordStrengthModule.forRoot(),

    FormlyBootstrapModule,
    FormlyModule.forRoot({
      wrappers: [
        {name: 'form-field-horizontal', component: FormlyHorizontalWrapper},
        {name: 'card-wrapper', component: ColCardWrapperComponent}
      ],
      validationMessages: [
        {name: 'required', message: 'This field is required'},
      ],
      types: [
        {name: 'file', component: FormlyFieldFile, wrappers: ['form-field']},
        {name: 'datepicker', component: FormlyFieldDatePicker, wrappers: ['form-field']},
        {name: 'ng-select', component: FormlyFieldNgSelect, wrappers: ['form-field']},
        {name: 'ng-select2', component: FormlyFieldNgSelect2, wrappers: ['form-field']},
        {name: 'editor', component: FormlyFieldEditor, wrappers: ['form-field']},
        {name: 'repeat', component: RepeatTypeComponent },
        {name: 'jsonapi-list-template', component: JsonapiListTemplateTypeComponent },
        {name: 'tabs', component: FormlyFieldTabs},
        { name: 'custom-template', component: FormlyFieldCustomTemplate, wrappers: ['form-field'] }
      ],
    }),
    TabsModule.forRoot(),
    NgMultiSelectDropDownModule.forRoot()
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttptokenInterceptor,
      multi: true
    },
    {
      provide: APP_INITIALIZER,
      useFactory: initializerConfigFn,
      multi: true,
      deps: [GlobalsService]
    }
  ],
  exports: [],
  bootstrap: [AppComponent]
})
export class AppModule {
}
